var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25H9.375V3.375C9.375 1.51392 7.86108 0 6 0C4.13892 0 2.625 1.51392 2.625 3.375V5.25H2.25C1.42158 5.25 0.75 5.92153 0.75 6.75V10.5C0.75 11.3284 1.42158 12 2.25 12H9.75C10.5784 12 11.25 11.3284 11.25 10.5V6.75C11.25 5.92153 10.5784 5.25 9.75 5.25ZM6.75 9C6.75 9.41419 6.41423 9.75 6 9.75C5.58577 9.75 5.25 9.41419 5.25 9V8.25C5.25 7.83581 5.58577 7.5 6 7.5C6.41423 7.5 6.75 7.83581 6.75 8.25V9ZM7.875 5.25H4.125V3.375C4.125 2.34082 4.9662 1.5 6 1.5C7.0338 1.5 7.875 2.34082 7.875 3.375V5.25Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7e7d7a8eb8b591d545429a6e999d4d5b.svg";
export { ForwardRef as ReactComponent };